import { action, observable, makeObservable } from 'mobx';

interface ILoader {
    receivedLength: number;
    totalLength: number;
    startTime: number;
}

const LATENCY_MS = 500;

export default class LoadingStore {
    isLoading = false;
    startTime: number | null = null;
    loaders: Record<string, ILoader> = {};

    constructor() {
        makeObservable(this, {
            isLoading: observable,
            startTime: observable,
            loaders: observable,
            startLoading: action,
            updateLoadingProgress: action,
            stopLoading: action
        });
    }

    get totalRequests(): number {
        return Object.keys(this.loaders).length;
    }

    get progress(): number {
        if (this.totalRequests === 0) return 0;
        return Math.max(0, 1 - Object.values(this.loaders).length / this.totalRequests);
    }

    get shouldDisplay(): boolean {
        return !!this.startTime && new Date().getTime() - this.startTime > LATENCY_MS;
    }

    startLoading(key: string): void {
        const startTime = new Date().getTime();

        this.isLoading = true;
        this.startTime = this.startTime === null ? startTime : this.startTime;
        this.loaders = {
            ...this.loaders,
            [key]: { receivedLength: 0, totalLength: 0, startTime }
        };
    }

    updateLoadingProgress(key: string, receivedLength: number, totalLength: number): void {
        this.loaders = {
            ...this.loaders,
            [key]: { ...this.loaders[key], receivedLength, totalLength }
        };
    }

    stopLoading(key: string): void {
        const { [key]: loader, ...rest } = this.loaders;
        this.isLoading = !!Object.keys(rest).length;

        if (!this.isLoading) {
            this.startTime = null;
        }

        this.loaders = rest;
    }
}
